import { render, staticRenderFns } from "./BuildingTransactionHistory.vue?vue&type=template&id=0f1b53aa&scoped=true&"
import script from "./BuildingTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./BuildingTransactionHistory.vue?vue&type=script&lang=js&"
import style0 from "./BuildingTransactionHistory.vue?vue&type=style&index=0&id=0f1b53aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1b53aa",
  null
  
)

export default component.exports